<div class="top-header-wrapper">
    <div class="top-header-left">
        <kw-contacts-nav></kw-contacts-nav>
    </div>
    <div class="top-header-center">
        <kv-message-nav></kv-message-nav>
    </div>
    <div class="top-header-right">
        <kw-social-nav></kw-social-nav>
    </div>
</div>